const ChevronUp = () => {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"  d="M5.99988 3.6345L1.63988 7.2675C1.21588 7.6215 0.584878 7.5635 0.231878 7.1395C-0.122122 6.7145 -0.0641224 6.0845 0.359878 5.7315L6.35988 0.731496C6.40688 0.692496 6.46188 0.672496 6.51388 0.643496C6.55588 0.619496 6.59188 0.590496 6.63788 0.572496C6.75288 0.527496 6.87388 0.500496 6.99588 0.500496C7.12588 0.500496 7.24688 0.527496 7.36188 0.572496C7.40788 0.590496 7.44388 0.619496 7.48588 0.643496C7.53788 0.672496 7.59288 0.692496 7.63988 0.731496L13.6399 5.7315C13.8769 5.9295 13.9999 6.2135 13.9999 6.4995C13.9999 6.7255 13.9239 6.9525 13.7679 7.1395C13.4149 7.5635 12.7839 7.6215 12.3599 7.2675L7.99988 3.6345L6.99588 2.6345" fill="currentColor" />
    </svg>
  );
};

export default ChevronUp;
